export default __webpack_public_path__ + "static/media/mooniverseText.30e64baf.png";